import './chat.css';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router';
import Navbar from "../components/navbar";
import AdGate from "../components/adGate";

import ChatMessage from '../components/chatMessage';
import ProblemBubble from '../components/problemBubble';
import InstructionsBubble from '../components/instructionsBubble';

function adjustTextareaHeight() {
  const textarea = document.getElementById('chatInput');
  if (!textarea) return;
  textarea.style.height = 'auto';
  textarea.style.height = textarea.scrollHeight + 'px';
}

function ChatPage({ API_ROOT, SECURITY_TOKEN }) {
  // Get problem name from URL
  const { problemId } = useParams();
  const [problemName] = useState(problemId);
  const [hasWatchedAd, setHasWatchedAd] = useState(false);
  const [adVideoId] = useState(() => {
    const options = ["n2kmtgQEY0E", "Sb3Wnxl9Ypk"];
    return options[Math.floor(Math.random() * options.length)];
  });
  const [newChatMessage, setNewChatMessage] = useState("");
  const [chatHistory, setChatHistory] = useState([]);
  const [isWaitingForResponse, setIsWaitingForResponse] = useState(false);

  // Dynamic CSS/HTML values
  const canSend = newChatMessage.trim().length > 0 && !isWaitingForResponse;
  const sendButtonClassNames = canSend ? "sendable" : undefined;
  const instructionsComponent = <InstructionsBubble />;
  const problemComponent =  <ProblemBubble apiRoot={API_ROOT} problemName={problemName} />;
  const waitingForResponseComponent = <ChatMessage isUser={false}>
    The AI is thinking...
  </ChatMessage>;
  let chatHistoryComponents = chatHistory.map(({content, role}, idx) => {
    return <ChatMessage
      isUser={role === 'user'}
      key={idx}
    >
      {content}
    </ChatMessage>
  });

  chatHistoryComponents.unshift(problemComponent);
  chatHistoryComponents.unshift(instructionsComponent);
  if (isWaitingForResponse) {
    chatHistoryComponents.push(waitingForResponseComponent);
  }

  // Auto-scrolling
  useEffect(() => {
    window.scrollTo(0, document.body.scrollHeight);
  }, [chatHistory]);

  // Chat responses
  const sendChatToBot = async (messageText) => {
    const userMessage = { content: messageText, role: 'user' };
  
    // Update chat history with the user's message
    setChatHistory([...chatHistory, userMessage]);
    setIsWaitingForResponse(true);

    // Request a response from Azure OpenAI service
    const botResponse = await axios.post(`${API_ROOT}/chat`, {
      problemId: problemName,
      messages: [...chatHistory, userMessage],
      securityToken: SECURITY_TOKEN
    });

    // Update chat history with the bot's response
    const botMessage = { content: botResponse.data, role: 'assistant' };
    setChatHistory([...chatHistory, userMessage, botMessage]);
    setIsWaitingForResponse(false);
  };

  const handleSend = () => {
    if (isWaitingForResponse) return;
    const messageText = newChatMessage.trim();
    if (!messageText) return;

    sendChatToBot(messageText);
    setNewChatMessage("");
    requestAnimationFrame(() => adjustTextareaHeight());
  };

  return (
    <div className="chatPage">
      <Navbar />
      <div className="chatPage__content">
        {!hasWatchedAd ? (
          <AdGate videoId={adVideoId} onComplete={() => setHasWatchedAd(true)} />
        ) : (
          <div id="chatPanel">
            <div id="chatHistory">
              {chatHistoryComponents}
            </div>
            <div id="chatControls">
              <textarea
                id="chatInput"
                placeholder="Type your response here"
                value={newChatMessage}
                onChange={e => {
                  setNewChatMessage(e.target.value);
                  adjustTextareaHeight();
                }}
                onKeyDown={e => {
                  if (e.key === 'Enter' && !e.shiftKey) {
                    e.preventDefault();
                    handleSend();
                  }
                }}
              />
              <button
                className={sendButtonClassNames}
                onClick={handleSend}
                disabled={!canSend}
              >
                Send
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ChatPage;
